export function isLMSFlow() {
    return new URL(window.location.href).searchParams.get("isLMSFlow") === 'true'; 
}